import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';

const PRODUCTS = {
  '20l-jar': {
    name: 'Vijaya Varshi 20L Jar',
    brand: 'Vijaya Varshi',
    capacity: '20 Litres',
    price: 60,
    deposit: 150,
    type: 'Refillable Jar',
    img: '/products/jar-20l.png?v=2',
    tag: 'Best Seller',
    tagColor: '#C8171A',
    tagBg: '#FDE8E8',
    gradient: 'linear-gradient(160deg, #FFF8F8 0%, #FDE8E8 100%)',
    accentColor: '#C8171A',
    description: 'Our flagship 20-litre crystal-clear refillable jar carries the iconic Vijaya Varshi mountain label. Built for families, offices and anyone who wants the most economical per-litre rate for purified water. One jar, endless refills.',
    specs: [
      { value: '20L', label: 'Capacity' },
      { value: '₹60', label: 'Per Refill' },
      { value: '₹150', label: 'Jar Deposit' },
      { value: 'Food Grade', label: 'Material' },
    ],
    highlights: [
      'Most economical — just ₹3 per litre',
      'Refillable food-grade BPA-free jar',
      'Ideal for families of 4–6 and offices',
      'Same-day delivery available',
      'Jar deposit fully refundable on return',
      'Compatible with all standard jar dispensers',
    ],
    usages: ['Home use', 'Office & workspace', 'Restaurants & canteens', 'Functions & events'],
    depositNote: 'A one-time refundable deposit of ₹150 is charged for the food-grade jar. Deposit is fully returned when you hand back the jar. Only ₹60 per refill from then on.',
  },
  '1l-bottle': {
    name: 'Vijaya Varshi 1L Bottle',
    brand: 'Vijaya Varshi',
    capacity: '1 Litre',
    price: 20,
    deposit: null,
    type: 'Sealed Bottle',
    img: '/products/bottle-1l.png?v=2',
    tag: 'Popular',
    tagColor: '#16a34a',
    tagBg: '#dcfce7',
    gradient: 'linear-gradient(160deg, #f0fdf4 0%, #dcfce7 100%)',
    accentColor: '#16a34a',
    description: 'The tall 1-litre sealed bottle with the Vijaya Varshi mountain-design label. Perfect for home use, gym sessions, office desks and dining tables. Hygienic tamper-evident seal with no deposit required.',
    specs: [
      { value: '1L', label: 'Capacity' },
      { value: '₹20', label: 'Per Bottle' },
      { value: 'Nil', label: 'Deposit' },
      { value: 'Sealed', label: 'Closure' },
    ],
    highlights: [
      'Tamper-evident hygienic seal',
      'No deposit — pay only for the water',
      'Great for dining tables & office desks',
      'Branded mountain-design Vijaya Varshi label',
      'Available in bulk packs',
    ],
    usages: ['Home dining', 'Office & desk', 'Gym & fitness', 'Gifting & hospitality'],
    depositNote: null,
  },
  '500ml-bottle': {
    name: 'Vijaya 500ml Bottle',
    brand: 'Vijaya',
    capacity: '500 ml',
    price: 10,
    deposit: null,
    type: 'Compact Bottle',
    img: '/products/bottle-500ml.png?v=2',
    tag: 'On-the-Go',
    tagColor: '#b45309',
    tagBg: '#fef3c7',
    gradient: 'linear-gradient(160deg, #fffbeb 0%, #fef3c7 100%)',
    accentColor: '#b45309',
    description: 'Compact 500ml bottle branded "Vijaya" — handy for school, travel, commuting and events. Lightweight and easy to slip into any bag. Same high-quality purified water in a convenient size.',
    specs: [
      { value: '500ml', label: 'Capacity' },
      { value: '₹10', label: 'Per Bottle' },
      { value: 'Nil', label: 'Deposit' },
      { value: 'Compact', label: 'Size' },
    ],
    highlights: [
      'Lightweight — perfect for bags & backpacks',
      'Ideal for school children & commuters',
      'Bulk packs available for schools & offices',
      'Sealed for freshness',
    ],
    usages: ['School & college', 'Travel & commute', 'Sports & outdoor', 'Bulk office supply'],
    depositNote: null,
  },
  '250ml-bottle': {
    name: 'Vijaya 250ml Bottle',
    brand: 'Vijaya',
    capacity: '250 ml',
    price: 6,
    deposit: null,
    type: 'Mini Bottle',
    img: '/products/bottle-250ml.png?v=2',
    tag: 'Pocket Friendly',
    tagColor: '#475569',
    tagBg: '#f1f5f9',
    gradient: 'linear-gradient(160deg, #f8fafc 0%, #f1f5f9 100%)',
    accentColor: '#475569',
    description: 'The smallest Vijaya bottle at just 250ml. Perfect for individual servings at functions, events and bulk gifting. Economical per-unit pricing when ordered in bulk packs. Great for catering and large gatherings.',
    specs: [
      { value: '250ml', label: 'Capacity' },
      { value: '₹6', label: 'Per Bottle' },
      { value: 'Nil', label: 'Deposit' },
      { value: 'Mini', label: 'Size' },
    ],
    highlights: [
      'Best price per bottle in the range',
      'Ideal for events, functions & catering',
      'Bulk discounts on large orders',
      'Individual serving size',
    ],
    usages: ['Weddings & events', 'Catering services', 'Corporate gifting', 'Individual servings'],
    depositNote: null,
  },
};

const ALL_PRODUCTS = [
  { slug: '20l-jar', name: '20L Jar', capacity: '20 Litres', price: 60, tag: 'Best Seller', tagBg: '#FDE8E8', tagColor: '#C8171A', headerBg: 'linear-gradient(160deg,#FFF8F8 0%,#FDE8E8 100%)', img: '/products/jar-20l.png?v=2' },
  { slug: '1l-bottle', name: '1L Bottle', capacity: '1 Litre', price: 20, tag: 'Popular', tagBg: '#dcfce7', tagColor: '#16a34a', headerBg: 'linear-gradient(160deg,#f0fdf4 0%,#dcfce7 100%)', img: '/products/bottle-1l.png?v=2' },
  { slug: '500ml-bottle', name: '500ml Bottle', capacity: '500 ml', price: 10, tag: 'On-the-Go', tagBg: '#fef3c7', tagColor: '#b45309', headerBg: 'linear-gradient(160deg,#fffbeb 0%,#fef3c7 100%)', img: '/products/bottle-500ml.png?v=2' },
  { slug: '250ml-bottle', name: '250ml Bottle', capacity: '250 ml', price: 6, tag: 'Pocket Friendly', tagBg: '#f1f5f9', tagColor: '#475569', headerBg: 'linear-gradient(160deg,#f8fafc 0%,#f1f5f9 100%)', img: '/products/bottle-250ml.png?v=2' },
];

export default function ProductDetailPage() {
  const { slug } = useParams();
  const p = PRODUCTS[slug];

  if (!p) return <Navigate to="/products" replace />;

  return (
    <div>
      {/* Slim Hero */}
      <section style={{ background: 'linear-gradient(160deg, #FFF8F8 0%, #FDE8E8 100%)', padding: '2rem 1.5rem', borderBottom: '1px solid #fecaca' }}>
        <div className="page-container">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem', fontSize: '0.82rem' }}>
            <Link to="/" style={{ color: '#94a3b8', textDecoration: 'none' }}>Home</Link>
            <span style={{ color: '#cbd5e1' }}>/</span>
            <Link to="/products" style={{ color: '#94a3b8', textDecoration: 'none' }}>Products</Link>
            <span style={{ color: '#cbd5e1' }}>/</span>
            <span style={{ color: '#C8171A', fontWeight: 600 }}>{p.name}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <h1 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', fontWeight: 800, color: '#0c1a2e', margin: 0, lineHeight: 1.2 }}>
              {p.name}
            </h1>
            <span style={{ background: p.tagBg, color: p.tagColor, padding: '0.3rem 0.9rem', borderRadius: '9999px', fontSize: '0.78rem', fontWeight: 700, flexShrink: 0 }}>
              {p.tag}
            </span>
          </div>
        </div>
      </section>

      {/* Two-Column Product Detail */}
      <section style={{ background: 'white', padding: '3rem 1.5rem' }}>
        <div className="page-container">
          <div className="product-detail-layout">

            {/* Left — sticky image + CTAs */}
            <div className="product-detail-image-wrap">
              <div style={{
                background: p.gradient,
                borderRadius: '20px',
                padding: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                minHeight: '380px',
                border: '1px solid rgba(0,0,0,0.06)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
              }}>
                <img
                  src={p.img}
                  alt={p.name}
                  onError={e => { e.target.style.opacity = '0'; }}
                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 14, display: 'block', filter: 'drop-shadow(0 12px 28px rgba(0,0,0,0.18))' }}
                />
              </div>
            </div>

            {/* Right — details */}
            <div>
              {/* Price */}
              <div style={{ marginBottom: '1.5rem' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', marginBottom: '0.35rem' }}>
                  <span style={{ fontSize: '1.85rem', fontWeight: 900, color: p.accentColor, lineHeight: 1 }}>₹{p.price}</span>
                  <span style={{ fontSize: '0.95rem', color: '#64748b', fontWeight: 500 }}>
                    per {p.type === 'Refillable Jar' ? 'refill' : 'bottle'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ background: '#f1f5f9', color: '#475569', padding: '0.25rem 0.75rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600 }}>
                    {p.type}
                  </span>
                  <span style={{ background: '#f1f5f9', color: '#475569', padding: '0.25rem 0.75rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600 }}>
                    {p.capacity}
                  </span>
                </div>
              </div>

              {/* Description */}
              <p className="text-justify" style={{ color: '#374151', lineHeight: 1.8, fontSize: '0.975rem', marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid #f1f5f9' }}>
                {p.description}
              </p>

              {/* Spec grid */}
              <div style={{ marginBottom: '1.75rem' }}>
                <h3 style={{ fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#94a3b8', marginBottom: '0.85rem' }}>
                  Specifications
                </h3>
                <div className="product-spec-grid">
                  {p.specs.map((s, i) => (
                    <div key={i} style={{
                      background: '#f8fafc',
                      border: '1px solid #e2e8f0',
                      borderRadius: '12px',
                      padding: '1rem 0.75rem',
                      textAlign: 'center',
                    }}>
                      <div style={{ fontSize: '1.3rem', fontWeight: 800, color: p.accentColor, marginBottom: '0.2rem', lineHeight: 1.1 }}>
                        {s.value}
                      </div>
                      <div style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        {s.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTAs */}
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <Link
                  to="/contact"
                  style={{ flex: 1, textAlign: 'center', background: '#C8171A', color: 'white', padding: '0.8rem 1rem', borderRadius: '10px', fontWeight: 700, fontSize: '0.95rem', textDecoration: 'none', boxShadow: '0 4px 14px rgba(200,23,26,0.3)' }}
                >
                  Order Now &rarr;
                </Link>
                <a
                  href="tel:8374422411"
                  style={{ flex: 1, textAlign: 'center', background: 'white', color: '#0c1a2e', border: '2px solid #e2e8f0', padding: '0.8rem 1rem', borderRadius: '10px', fontWeight: 700, fontSize: '0.95rem', textDecoration: 'none' }}
                >
                  Call to Order
                </a>
              </div>
            </div>
          </div>

          {/* Why Choose This — full width inside same section */}
          <div style={{ marginTop: '3rem', paddingTop: '2.5rem', borderTop: '1px solid #f1f5f9' }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#0c1a2e', marginBottom: '1.25rem' }}>Why Choose This Product</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '0.75rem' }}>
              {p.highlights.map((h, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.85rem 1.1rem', background: '#f0fdf4', borderRadius: '10px', border: '1px solid #bbf7d0' }}>
                  <span style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#16a34a', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', fontWeight: 900, flexShrink: 0 }}>
                    ✓
                  </span>
                  <span style={{ fontSize: '0.9rem', color: '#166534', fontWeight: 500 }}>{h}</span>
                </div>
              ))}
            </div>

            {/* Deposit note — below Why Choose This */}
            {p.depositNote && (
              <div className="text-justify" style={{ marginTop: '1.5rem', background: '#fefce8', border: '1px solid #fde68a', borderRadius: '10px', padding: '1rem 1.25rem', fontSize: '0.875rem', color: '#713f12', lineHeight: 1.7 }}>
                <strong>Deposit Info:</strong> {p.depositNote}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Other Products */}
      <section className="section" style={{ background: '#f8fafc' }}>
        <div className="page-container">
          <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <h2 className="section-title" style={{ marginBottom: '0.4rem' }}>Explore the Full Range</h2>
            <p className="section-subtitle">Same purity, every size — find the right one for you</p>
          </div>
          <div className="grid grid-3" style={{ gap: '1.25rem' }}>
            {ALL_PRODUCTS.filter(ap => ap.slug !== slug).map(ap => (
              <Link
                key={ap.slug}
                to={'/products/' + ap.slug}
                style={{ textDecoration: 'none', display: 'block', borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--border-light)', background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', transition: 'transform 0.25s, box-shadow 0.25s' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 16px 36px rgba(29,78,216,0.14)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; }}
              >
                <div style={{ background: ap.headerBg, padding: '1.5rem 1rem 1rem', textAlign: 'center', position: 'relative', height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ position: 'absolute', top: '0.75rem', left: '0.75rem', background: ap.tagBg, color: ap.tagColor, borderRadius: '9999px', padding: '0.2rem 0.65rem', fontSize: '0.68rem', fontWeight: 700 }}>
                    {ap.tag}
                  </span>
                  <img
                    src={ap.img}
                    alt={ap.name}
                    onError={e => { e.target.style.opacity = '0'; }}
                    style={{ maxHeight: 240, maxWidth: 200, objectFit: 'contain', borderRadius: 12, filter: 'drop-shadow(0 6px 16px rgba(0,0,0,0.13))' }}
                  />
                </div>
                <div style={{ padding: '1.25rem 1.25rem 1.5rem' }}>
                  <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.2rem' }}>Vijaya Varshi</div>
                  <div style={{ fontWeight: 800, fontSize: '1rem', color: 'var(--text-dark)', marginBottom: '0.2rem' }}>{ap.name}</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.75rem' }}>{ap.capacity}</div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '1.5rem', fontWeight: 900, color: 'var(--brand)' }}>₹{ap.price}</span>
                    <span style={{ background: 'var(--brand)', color: 'white', borderRadius: '8px', padding: '0.4rem 0.85rem', fontSize: '0.8125rem', fontWeight: 700 }}>
                      View &rarr;
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: 'var(--brand)', padding: '3.5rem 1.5rem', textAlign: 'center' }}>
        <div className="page-container" style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.85rem', fontWeight: 800, color: 'white', marginBottom: '0.75rem' }}>
            Ready to Order {p.name}?
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem' }}>
            Contact us today and get your first delivery arranged. We serve all areas of Hyderabad.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" style={{ background: 'white', color: 'var(--brand)', padding: '0.85rem 2.25rem', borderRadius: '10px', fontWeight: 700, fontSize: '1.0625rem', textDecoration: 'none' }}>
              Contact Us to Order
            </Link>
            <a href="tel:8374422411" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', border: '2px solid rgba(255,255,255,0.45)', padding: '0.85rem 2.25rem', borderRadius: '10px', fontWeight: 700, fontSize: '1.0625rem', textDecoration: 'none' }}>
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
